<template>
  <div>
    <List v-if="formStatus == 'list'" @addCallback="handleAdd"></List>
    <DetailOne v-if="formStatus == 'set1'" :category="category" @formCallback="handleFormStatus" @back="back"></DetailOne>
	<DetailTwo v-if="formStatus == 'set2'" :category="category" @formCallback="handleFormStatus" @back="back"></DetailTwo>
	<DetailThree v-if="formStatus == 'set3'" :category="category" @formCallback="handleFormStatus" @back="back"></DetailThree>
  </div>
</template>

<script>
import List from "@/views/pd/check/category/List";
import DetailOne from "@/views/pd/check/category/DetailOne";
import DetailTwo from "@/views/pd/check/category/DetailTwo";
import DetailThree from "@/views/pd/check/category/DetailThree";
export default {
  name: "Pd-Manager-Category",
  components: {List, DetailOne, DetailTwo, DetailThree},
  data(){
    return {
      formStatus:'list',
	  category:null
    }
  },
  methods:{
    handleAdd(data){
      this.formStatus = data.formStatus;
	  this.category=data.category;
    },
    handleFormStatus(formStatus){
      this.formStatus = formStatus
    },
	back(){
		this.formStatus='list';
	}
  }
}
</script>

<style scoped>

</style>